import { logger } from '../../utils/logger';
import { handleCtiPostMessage } from './cti-events';
import { isAllowedCtiMessageOrigin } from './cti-origin.util';

function handleCtiMessage(event: MessageEvent): void {
  if (!isAllowedCtiMessageOrigin(event.origin)) {
    logger.warn('[SAP CTI] Ignoring postMessage from disallowed origin', {
      origin: event.origin,
      hint: 'Ensure features.sapC4cBaseUrl matches the SAP Agent Desktop parent origin',
    });
    return;
  }

  if (event.data) {
    const dataType = typeof event.data;
    const preview =
      dataType === 'string'
        ? event.data.substring(0, 200)
        : JSON.stringify(event.data).substring(0, 200);
    logger.debug('[SAP CTI] PostMessage received:', {
      type: dataType,
      preview,
      origin: event.origin,
    });
  }

  if (handleCtiPostMessage(event.data)) {
    return;
  }

  if (event.data?.type) {
    logger.debug('[SAP CTI] Message received, type:', event.data.type, event.data);
  }
}

export function initCtiContextListener(): void {
  window.addEventListener('message', handleCtiMessage);
  logger.debug('[SAP CTI] PostMessage listener initialized');
}
